<template>
  <div class="auth-container password-reset-container">
    <img class="logo" alt="Feeds.automated logo" src="/app/images/logo.svg" />
    <p class="my-4">{{ $t('auth.set_new_password') }}</p>
    <ValidationObserver ref="observer" v-slot="{ invalid }" class="d-flex flex-column w-50 align-items-center">
      <validation-provider class="mb-4 d-flex flex-column password-container" mode="lazy" :rules="{
          required: true,
          min_value: 8,
          regex: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/
        }" v-slot="{ errors }" vid="password">
        <input id="password" v-model="newPassword" class="form-control" type="password" :placeholder="$t('auth.input_password')">
        <eye-icon @click="togglePasswordPreview"></eye-icon>
        <span class="validation-error-required pl-2" v-if="errors[0] === 'Pole jest wymagane'">{{ $t('validations.required') }}</span>
        <span class="validation-error-required pl-2" v-if="errors[0] === 'password is not valid.'">{{ $t('validations.password_invalid') }}</span>
      </validation-provider>
      <validation-provider class="mb-4 password-container" mode="lazy" rules="required|confirmed:password" v-slot="{ errors }">
        <input id="passwordConfirm" v-model="newPasswordConfirm" class="form-control" type="password" :placeholder="$t('auth.input_password_repeat')">
        <eye-icon @click="togglePasswordConfirmPreview"></eye-icon>
        <span class="validation-error-required pl-2" v-if="errors[0] === 'Pole jest wymagane'">{{ $t('validations.required') }}</span>
        <span class="validation-error-required pl-2" v-else-if="errors[0] === 'confirmPassword is not valid.'">{{ $t('validations.passwords_not_match') }}</span>
      </validation-provider>
      <button type="submit" class="btn btn-large btn-orange" @click="resetPassword" :disabled="invalid">{{ $t('auth.change_password') }}</button>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, confirmed, regex, min } from 'vee-validate/dist/rules'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import axios from 'axios'
import { EyeIcon } from 'vue-feather-icons'

extend('required', {
  ...required
})

extend('confirmed', {
  ...confirmed
})

extend('regex', {
  ...regex
})

extend('min_value', {
  ...min
})

export default {
  name: 'PasswordResetConfirm',

  data () {
    return {
      newPassword: null,
      newPasswordConfirm: null
    }
  },

  mounted () {
    window.addEventListener('keypress', (e) => {
      if (e.keyCode === 13) {
        this.resetPassword()
      }
    })
  },

  methods: {
    resetPassword () {
      if (this.$refs.observer !== undefined) {
        if (this.$refs.observer.flags.valid) {
          axios.post(process.env.VUE_APP_API_ENDPOINT + '/auth/confirm_reset', {
            newPassword: this.newPassword,
            token: this.$route.params.token
          })
            .then((response) => {
              if ((response.status === 201) || (response.status === 200)) {
                this.$router.push({ name: 'auth.login' })
              }
            })
            .catch((error) => {
              if (error.response) {
                this.$router.push({ name: 'auth.error', params: { errorCode: error.response.data.statusCode, errorMessage: error.response.data.message } })
              }
            })
        }
      }
    },

    togglePasswordPreview () {
      const passwordInput = document.getElementById('password')
      if (passwordInput.type === 'password') passwordInput.type = 'text'
      else passwordInput.type = 'password'
    },

    togglePasswordConfirmPreview () {
      const passwordInput = document.getElementById('passwordConfirm')
      if (passwordInput.type === 'password') passwordInput.type = 'text'
      else passwordInput.type = 'password'
    }
  },

  components: { EyeIcon, ValidationObserver, ValidationProvider }
}
</script>
